module.exports = __webpack_public_path__ + "img/icon_profil_white_white.23fa1120.svg";